import React, { useState, useEffect, useRef } from "react";
import "./themoon.scss";
import { Dropdown, Modal, Offcanvas, Tab, Tabs } from "react-bootstrap";
import gsap from "gsap";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import lottie from "lottie-web";
import Balance from "../../hooks/dataFetcher/BalanceOf";
import { useRecoilValue } from "recoil";
import {
  useEthInternalBalace,
  usePermisions,
  usePublicClient,
  userSmartAccount,
  userSmartAccountClient,
  useSmartSession,
} from "../recoilAtom";
import { GameAllCalls } from "../../hooks/dataSender/gameEndTime";
import Loader from "../../hooks/loader";
import { useCheckAllowance } from "../../hooks/dataSender/Allowance";
import { CashOut } from "../../hooks/dataSender/cashout";
import { CRASH_GAME_CONTRACT } from "../../utils/Enviroment";
import useWeb3 from "../../hooks/useWeb3";
import { ethers, Interface, Log } from "ethers";
import CrashGameABI from "../../utils/CrashGameAbi.json";
import { callCrashGameGraphQLQuery } from "../../utils/axiosClient";
import { getL1BatchBlockRange } from "viem/zksync";
import Web3 from "web3";
import { useWeb3React } from "@web3-react/core";
import TotalLiquidity from "../../hooks/dataFetcher/TotalLiquidity";
import {
  getLiquidityPool,
  CrashGameContract,
} from "../../utils/contractHelpers";
import WalletConnectModel from "../walletConnectModel";
import { toast } from "react-toastify";
import CreashGameAbi from "../../utils/CrashGameAbi.json";
import axios from "axios";
import { data } from "jquery";
import { useSessionPermissions } from "../../hooks/checkSessionPermissions";
import showToast from "../../hooks/showToast";
import { useSocketEvents } from "../../hooks/sokit";
import CountdownTimer from "../Liquidity/CountdownTimer";
import CountdownTimer1 from "../Liquidity/CountDownTimer1";
import RoundData from "./RoundData";

gsap.registerPlugin(MotionPathPlugin);
const Themoon = () => {
  const events = [
    {
      eventName: "connect",
      handler: () => console.log("Connected to the server"),
    },
    {
      eventName: "gameCrashed",
      handler: (data) => {
        setMultiplier(data.maxMultiplier);
        triggerInstantCrash();
        setShouldCrashNow(true);
        // setBetPlaced(false);
        // setCounDownCheck(false);
        console.log(data, "Connected to the server");
        setShouldRun(false);
      },
    },
    {
      eventName: "gameStarted",
      handler: (data) => {
        // setMultiplier(data.maxMultiplier);
        beginCountdown(0, "Place Your Bet", false);
        startRound(200, 0);
        console.log(data, "Connected to the server");
        setShouldRun(true);
      },
    },
    {
      eventName: "roundStarted",
      handler: (data) => {
        setShouldRun(true);
        console.log("sokitt roundStarted", data);
        beginCountdown(11, "Waiting for others to join", false);
      },
    },
    {
      eventName: "gameStartedEventHit",
      handler: (data) => {
        console.log("sokitt gameStartedEventHit", data);
        setShouldRun(true);
        fetchEthBalance3(
          parseInt(data?.startTime),
          parseInt(data?.currentIndex),
          data?.crashDelay
        );
      },
    },
  ];
  useSocketEvents(events);

  const [theme, setTheme] = useState("light");
  const [show11, setShow11] = useState(false);

  const handleClose11 = () => setShow11(false);
  const handleShow11 = () => setShow11(true);
  const {
    TotalLiquidityHook,
    TotalWinningHook,
    TotalVolumeHook,
    JackpotHook,
    baughtBackhook,
  } = TotalLiquidity();
  const [isTimerExpired, setIsTimerExpired] = useState(false);
  const [currentLiquidity, setCurrentLiquidity] = useState(null);
  const [totalWinnings, setTotalWinnings] = useState(null);
  const [totalVolume, setTotalVolume] = useState(null);
  const [baughtBack, setbaughtBack] = useState(null);
  const [maxBet, setMaxBet] = useState(null);
  const [gameSypherText, setGameSypherText] = useState(null);
  const [gametartTimeContract, setGametartTimeContract] = useState(null);
  const [cashoutotherCheck, setCashoutOtherCheck] = useState(false);
  const { GameCurrentIndexHood, GamePendingHook, GameRoundHook } =
    GameAllCalls();
  const web3 = useWeb3();
  let { account } = useWeb3React();
  let cashoutSaved = localStorage.getItem("AutoCashOut");
  const { CashoutHook, PlaceBeteHook } = CashOut();
  const rocketRef = useRef(null);
  const pathRef = useRef(null);
  const tlRef = useRef(null);
  const intervalRef = useRef(null);
  const { checkAllowance } = useCheckAllowance();
  const { BalanceHook } = Balance();
  const [autoCashout, setAutoCashOut] = useState(null);
  const [recipentData, setReciptData] = useState([]);
  const [gameRunningTime, setGameRunningTime] = useState(null);
  const [pendingBetAmount, setPendingBetAmount] = useState(null);
  const [pendingBetStatus, setPendingBetStatus] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(null);
  const smartAccount = useRecoilValue(userSmartAccount);
  const meClient = useRecoilValue(userSmartAccountClient);
  // const session = useRecoilValue(useSmartSession);
  // const permission = useRecoilValue(usePermisions);
  const [ethBalanceForTrans, sectEthBalanceForTrans] = useState(null);
  const ethinternalBlce = useRecoilValue(useEthInternalBalace);

  const publicClient = useRecoilValue(usePublicClient);
  const [userBalance, setUserBalance] = useState(null);
  const [gameStartTime1, setGameStartTime1] = useState(null);
  const [gameStartTime, setGameStartTime] = useState(null);
  const [multiplier, setMultiplier] = useState();
  const [crashPoint, setCrashPoint] = useState(0);
  const [gameState, setGameState] = useState("waiting");
  const [betPlaced, setBetPlaced] = useState(false);
  const [betAmount, setBetAmount] = useState("");
  const [autoBetNext, setAutoBetNext] = useState(false);
  const [autoBetAmount, setAutoBetAmount] = useState("");
  const [showCashout, setShowCashout] = useState(false);
  const [showWinModal, setShowWinModal] = useState(false);
  const [winAmount, setWinAmount] = useState(0);
  const [countdown, setCountdown] = useState(0);
  const [countdownText, setCountdownText] = useState("");
  const [xShift, setXShift] = useState(0);
  const [yShift, setYShift] = useState(0);
  const [crashed, setCrashed] = useState(false);
  const [keepRunning, setKeepRunning] = useState(true);
  const [winPrice, setWinprice] = useState(null);
  const [winstatus, setWinstatus] = useState(null);
  const [winxxx, setWinnxxx] = useState(null);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");
  const [countDownCheck, setCounDownCheck] = useState(false);
  const [cashoutBool, setcashoutBool] = useState(false);
  const [loaderText, setLoaderText] = useState({
    heading: "Loading",
    paragraph: "",
  });
  const [playerHistory, setPlayerHistory] = useState([]);

  const [playerHistory1, setPlayerHistory1] = useState([]);
  const [playerBetHHistory, setPlayerBetHistory] = useState([]);

  const [statusForRountStar, setstatusForRountStar] = useState(null);
  const [indexForCRASH, setIndexForCrsh] = useState(null);
  const [uniquePlayersCount, setUniquePlayersCount] = useState(0);
  const [recentGamesData, setRecentGamesData] = useState([]);
  const [shouldRun, setShouldRun] = useState(false); // control state
  const { grantPermissions } = useSessionPermissions();
  const [currentTime, setCurrentTime] = useState(null);
  const [mergedBetHistory, setMergedBetHistory] = useState([]);
  const [audioAllowed, setAudioAllowed] = useState(false);
  const lastX = useRef(1);
  const lastY = useRef(1);
  const crashSoundRef = useRef(null);
  // Add these new refs for accurate timing
  const gameStartTimeGame = useRef(null);
  const gameTimeOffset = useRef(0);
  const gameUpdateLoop = useRef(null);
  const multiplierUpdateLoop = useRef(null); // Separate loop for multiplier updates

  // console.log(isTimerExpired, "isTimerExpired");

  const xLabels = Array.from({ length: 5 }, (_, i) => `${1 + i + xShift}x`);
  const yLabels = Array.from({ length: 5 }, (_, i) => `${1 + i + yShift}s`);

  // Add a state to trigger instant crash
  const [shouldCrashNow, setShouldCrashNow] = useState(false);

  // Function to get accurate elapsed time that works even when tab is inactive
  const getAccurateElapsedTime = () => {
    if (!gameStartTimeGame.current) return 0;
    return (
      (performance.now() - gameStartTimeGame.current + gameTimeOffset.current) /
      1000
    );
  };

  // Function to trigger instant crash
  const triggerInstantCrash = () => {
    setShouldCrashNow(true);
    // setBetPlaced(false);
    // setCounDownCheck(false);
  };

  // Function to handle instant crash
  const handleInstantCrash = () => {
    // Kill all animations immediately
    if (tlRef.current) {
      tlRef.current.kill();
      tlRef.current = null;
    }

    // Clear intervals and update loops
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    if (gameUpdateLoop.current) {
      cancelAnimationFrame(gameUpdateLoop.current);
      gameUpdateLoop.current = null;
    }

    if (multiplierUpdateLoop.current) {
      cancelAnimationFrame(multiplierUpdateLoop.current);
      multiplierUpdateLoop.current = null;
    }

    // Stop the game timer
    gameStartTimeGame.current = null;
    gameTimeOffset.current = 0;

    // Get current multiplier and crash at that point
    const currentMultiplier = multiplier || 1.0;

    // Trigger crash with current multiplier
    handleGameCrash(currentMultiplier);

    // Reset the crash trigger state
    setShouldCrashNow(false);
  };

  // useEffect to watch for instant crash trigger
  useEffect(() => {
    if (shouldCrashNow) {
      handleInstantCrash();
    }
  }, [shouldCrashNow]);

  // Prevent GSAP from pausing when tab becomes inactive
  useEffect(() => {
    // Prevent GSAP from auto-pausing when page is hidden
    gsap.ticker.lagSmoothing(0);

    // Force GSAP to continue running
    gsap.globalTimeline.paused(false);

    return () => {
      // Cleanup if needed
    };
  }, []);

  // Add visibility change handler to prevent game from stopping
  useEffect(() => {
    const handleVisibilityChange = () => {
      // Don't pause the game when tab becomes hidden
      if (document.hidden) {
      } else {
        // Sync visual elements when tab becomes visible again
        if (gameState === "running" && gameStartTimeGame.current) {
          const actualElapsedTime = getAccurateElapsedTime();
          const crashAt = crashPoint || 2.0;
          const totalDuration = calculateTotalDuration(crashAt);

          // Check if game should have crashed while tab was hidden
          if (actualElapsedTime >= totalDuration) {
            handleGameCrash(crashAt);
            return;
          }

          const current = calculateMultiplierFromTime(actualElapsedTime);
          setMultiplier(current);
          updateShifts(current, actualElapsedTime);
        }
      }
    };

    const handleFocus = () => {
      // Sync visual elements with actual game time
      if (gameState === "running" && gameStartTimeGame.current) {
        const actualTime = getAccurateElapsedTime();
        const current = calculateMultiplierFromTime(actualTime);
        setMultiplier(current);
      }
    };

    const handleBlur = () => {
      // Game logic continues, just log for debugging
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("focus", handleFocus);
    window.addEventListener("blur", handleBlur);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("focus", handleFocus);
      window.removeEventListener("blur", handleBlur);
    };
  }, [gameState, crashPoint, multiplier]);

  // Function to update shifts based on current values
  const updateShifts = (currentMultiplier, elapsedTime) => {
    const newXShift = Math.max(0, Math.floor(currentMultiplier) - 1);
    const newYShift = Math.max(0, Math.floor(elapsedTime) - 1);

    // Only update if values have changed
    if (newXShift !== xShift) {
      setXShift(newXShift);
      lastX.current = Math.floor(currentMultiplier);
    }

    if (newYShift !== yShift) {
      setYShift(newYShift);
      lastY.current = Math.floor(elapsedTime);
    }
  };

  // Main function for starting a round (new or joining late) - MODIFIED FOR CONTINUOUS TIMING
  const startRound = (crashValue, stagingTime) => {
    setCounDownCheck(false);
    if (tlRef.current) tlRef.current.kill();
    if (intervalRef.current) clearInterval(intervalRef.current);
    if (gameUpdateLoop.current) cancelAnimationFrame(gameUpdateLoop.current);
    if (multiplierUpdateLoop.current)
      cancelAnimationFrame(multiplierUpdateLoop.current);

    const path = pathRef.current;
    const rocket = rocketRef.current;
    const pathLength = path.getTotalLength();

    const crashAt = parseFloat(crashValue.toFixed(2));
    const totalDuration = calculateTotalDuration(crashAt);
    const elapsedTime = parseFloat(stagingTime.toFixed(2));

    // Set game start time accounting for elapsed time
    gameStartTimeGame.current = performance.now();
    gameTimeOffset.current = elapsedTime * 1000; // Convert to milliseconds

    // Calculate remaining duration
    const remainingDuration = Math.max(0, totalDuration - elapsedTime);

    // Check if game should already be crashed
    if (elapsedTime >= totalDuration) {
      handleGameCrash(crashAt);
      return;
    }

    // Calculate current multiplier and progress based on elapsed time
    const currentMultiplier = calculateMultiplierFromTime(elapsedTime);
    const currentProgress = elapsedTime / totalDuration;

    // Set initial states
    gsap.set(path, {
      strokeDasharray: pathLength,
      strokeDashoffset: pathLength * (1 - currentProgress), // Start from current progress
    });

    gsap.set(rocket, {
      opacity: 1,
      scale: 1,
      x: 0,
      y: 0,
    });

    // Initialize shifts based on current multiplier and time
    initializeShifts(currentMultiplier, elapsedTime);

    setCrashPoint(crashAt);
    setMultiplier(currentMultiplier);
    setGameState("running");

    if (autoBetNext && autoBetAmount) {
      setBetPlaced(true);
      setBetAmount(autoBetAmount);
      setAutoBetNext(false);
      setShowCashout(true);
    } else {
      setShowCashout(betPlaced);
    }

    // Continuous update loop that works regardless of tab visibility
    const updateGameState = () => {
      // Don't check gameState here as it might cause timing issues
      if (shouldCrashNow || !gameStartTimeGame.current) {
        gameUpdateLoop.current = null;
        return;
      }

      const actualElapsedTime = getAccurateElapsedTime();
      const timeProgress = actualElapsedTime / totalDuration;

      // Check if game should crash
      if (actualElapsedTime >= totalDuration) {
        handleGameCrash(crashAt);
        return;
      }

      // Update shifts (but not multiplier - that's handled by separate loop)
      const current = calculateMultiplierFromTime(actualElapsedTime);
      updateShifts(current, actualElapsedTime);

      // Continue the loop
      gameUpdateLoop.current = requestAnimationFrame(updateGameState);
    };

    // Start the continuous update loop
    gameUpdateLoop.current = requestAnimationFrame(updateGameState);

    // Separate high-frequency loop for smooth multiplier updates when tab is visible
    const updateMultiplierDisplay = () => {
      if (!gameStartTimeGame.current || shouldCrashNow) {
        multiplierUpdateLoop.current = null;
        return;
      }

      const actualElapsedTime = getAccurateElapsedTime();
      const totalDuration = calculateTotalDuration(crashAt);

      // Check if game should crash
      if (actualElapsedTime >= totalDuration) {
        return; // Let the main loop handle the crash
      }

      // Update multiplier display more frequently for smooth animation
      const current = calculateMultiplierFromTime(actualElapsedTime);
      setMultiplier(current);

      // Continue the multiplier update loop
      multiplierUpdateLoop.current = requestAnimationFrame(
        updateMultiplierDisplay
      );
    };

    // Start both loops
    multiplierUpdateLoop.current = requestAnimationFrame(
      updateMultiplierDisplay
    );

    // Keep animations for visual effects - GSAP handles smooth path drawing
    const tl = gsap.timeline();
    tlRef.current = tl;

    // Continue path animation from current progress (normal speed) - this draws the line smoothly
    tl.to(
      path,
      {
        strokeDashoffset: 0,
        duration: Math.min(4, remainingDuration), // 4 seconds or remaining time if less
        ease: "power1.out",
      },
      0
    );

    // Rocket reaches moon in 4 seconds, then stays there - GSAP handles smooth movement
    tl.to(
      rocket,
      {
        duration: Math.min(4, remainingDuration), // 4 seconds or remaining time if less
        ease: "power1.out",
        motionPath: {
          path: path,
          align: path,
          alignOrigin: [0.5, 0.63],
          autoRotate: true,
          start: currentProgress,
          end: 1, // Reach the end (moon) with slower pace
        },
      },
      0
    );

    // Keep rocket at moon and continue updating multiplier
    if (remainingDuration > 4) {
      tl.to(
        rocket,
        {
          duration: remainingDuration - 4,
          ease: "none",
          x: "+=0", // No movement, just time passing
        },
        4
      );
    }

    // Sync GSAP timeline with our custom crash detection
    tl.call(
      () => {
        // This ensures crash happens at the right time even if GSAP timing is off
        const actualTime = getAccurateElapsedTime();
        if (actualTime >= totalDuration && !shouldCrashNow) {
          handleGameCrash(crashAt);
        }
      },
      [],
      remainingDuration // Call at the end of the timeline
    );
  };

  // Calculate total duration based on crash value
  const calculateTotalDuration = (crashValue) => {
    if (crashValue <= 1) {
      return 10 * crashValue;
    } else {
      const additionalMultipliers = crashValue - 1;
      return 10 + additionalMultipliers * 5;
    }
  };

  // Calculate multiplier based on elapsed time
  const calculateMultiplierFromTime = (elapsedTime) => {
    if (elapsedTime <= 10) {
      // Phase 1: 1x to 2x (0-10 seconds)
      return parseFloat((1 + elapsedTime / 10).toFixed(2));
    } else if (elapsedTime <= 20) {
      // Phase 2: 2x to 4x (10-20 seconds)
      const additionalTime = elapsedTime - 10;
      const additionalMultiplier = (additionalTime / 10) * 2; // 2x increase over 10 seconds
      return parseFloat((2 + additionalMultiplier).toFixed(2));
    } else {
      // Phase 3: Use new formula M(t) = 4 × (1 + 0.039 × (t - 20)^1.5)
      const t = elapsedTime;
      const multiplier = 4 * (1 + 0.039 * Math.pow(t - 20, 1.5));
      return parseFloat(multiplier.toFixed(2));
    }
  };

  // Calculate multiplier based on progress and crash value
  const calculateMultiplierFromProgress = (progress, crashValue) => {
    const totalDuration = calculateTotalDuration(crashValue);
    const currentTime = progress * totalDuration;
    return calculateMultiplierFromTime(currentTime);
  };

  // Initialize shifts based on current state - FIXED
  const initializeShifts = (currentMultiplier, elapsedTime) => {
    const xShiftValue = Math.max(0, Math.floor(currentMultiplier) - 1);
    const yShiftValue = Math.max(0, Math.floor(elapsedTime) - 1);

    setXShift(xShiftValue);
    setYShift(yShiftValue);
    lastX.current = Math.floor(currentMultiplier);
    lastY.current = Math.floor(elapsedTime);
  };

  // Enhanced crash handling that works with continuous timing
  const handleGameCrash = (crashAt) => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    if (gameUpdateLoop.current) {
      cancelAnimationFrame(gameUpdateLoop.current);
      gameUpdateLoop.current = null;
    }
    if (multiplierUpdateLoop.current) {
      cancelAnimationFrame(multiplierUpdateLoop.current);
      multiplierUpdateLoop.current = null;
    }

    // Stop the game timer
    gameStartTimeGame.current = null;
    gameTimeOffset.current = 0;

    setMultiplier(crashAt);
    setGameState("waiting");
    setShowCashout(false);
    setBetPlaced(false);
    setCrashed(true);
    setKeepRunning(true);
    // fetchEthBalance();
    // fetchData();
    // fetchEthBalance22();
    localStorage.removeItem("AutoCashOut");
    setAutoCashOut("");
    // timeeeeee();
    setIsTimerExpired(false);
    if (!cashoutotherCheck) {
      fetchEthBalanceAfter1(currentIndex + 1);
    } else {
      fetchEthBalanceAfter1(currentIndex);
      setcashoutBool(false);
      setCashoutOtherCheck(false);
    }
  };

  const progressPercent = countdown * 100;

  const container2 = useRef(null);
  const animationRef = useRef(null);

  useEffect(() => {
    const animation2 = lottie.loadAnimation({
      container: container2.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: "/assets/Moon.json",
    });

    // Prevent Lottie from pausing when tab is inactive
    const originalPlay = animation2.play;
    animation2.play = function () {
      originalPlay.call(this);
      // Force continue playing even when tab is hidden
      if (document.hidden) {
        setTimeout(() => this.play(), 100);
      }
    };

    return () => {
      animation2?.destroy();
    };
  }, []);
  const crashSoundPlayedRef = useRef(false);
  const audioLoadedRef = useRef(false);

  useEffect(() => {
    const audio = new Audio("/problem.mp3");

    // Ensure audio is loaded before trying to play
    audio.addEventListener("loadeddata", () => {
      audioLoadedRef.current = true;
    });

    audio.addEventListener("error", (e) => {
      console.warn("Audio failed to load:", e);
    });

    // Preload the audio
    audio.preload = "auto";
    audio.load();

    crashSoundRef.current = audio;
  }, []);

  // Allow audio after first user interaction
  useEffect(() => {
    const enableAudio = async () => {
      setAudioAllowed(true);

      // Try to resume audio context if it's suspended
      if (crashSoundRef.current) {
        try {
          await crashSoundRef.current.play();
          crashSoundRef.current.pause();
          crashSoundRef.current.currentTime = 0;
        } catch (e) {
          console.warn("Audio context test failed:", e);
        }
      }

      window.removeEventListener("click", enableAudio);
      window.removeEventListener("touchstart", enableAudio);
    };

    window.addEventListener("click", enableAudio);
    window.addEventListener("touchstart", enableAudio); // For mobile
    return () => {
      window.removeEventListener("click", enableAudio);
      window.removeEventListener("touchstart", enableAudio);
    };
  }, []);

  useEffect(() => {
    if (!rocketRef.current) return;

    if (animationRef.current) {
      animationRef.current.destroy();
    }

    const animationPath = crashed
      ? "/assets/blast.json"
      : "/assets/Rocketanim.json";

    animationRef.current = lottie.loadAnimation({
      container: rocketRef.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: animationPath,
    });

    animationRef.current.setSpeed(1.5);

    // ✅ Play crash sound with better error handling
    if (crashed && !crashSoundPlayedRef.current) {
      playCrashSound();
    }

    // Prevent Lottie from pausing on inactive tab
    const originalPlay = animationRef.current.play;
    animationRef.current.play = function () {
      originalPlay.call(this);
      if (document.hidden) {
        setTimeout(() => this.play(), 100);
      }
    };

    return () => {
      animationRef.current?.destroy();
    };
  }, [crashed, audioAllowed]);

  // Separate function for playing crash sound
  const playCrashSound = async () => {
    if (
      !crashSoundRef.current ||
      !audioAllowed ||
      !audioLoadedRef.current ||
      document.hidden ||
      crashSoundPlayedRef.current
    ) {
      return;
    }

    try {
      // Reset audio to beginning
      crashSoundRef.current.currentTime = 0;

      // Try to play
      const playPromise = crashSoundRef.current.play();

      if (playPromise !== undefined) {
        await playPromise;
        crashSoundPlayedRef.current = true;
      }
    } catch (error) {
      console.warn("Crash sound play failed:", error);

      // If it fails, try to re-enable audio on next user interaction
      if (error.name === "NotAllowedError") {
        setAudioAllowed(false);
        const reEnableAudio = () => {
          setAudioAllowed(true);
          window.removeEventListener("click", reEnableAudio);
        };
        window.addEventListener("click", reEnableAudio, { once: true });
      }
    }
  };

  // Reset crash sound flag when game restarts
  useEffect(() => {
    if (!crashed) {
      crashSoundPlayedRef.current = false;
    }
  }, [crashed]);

  // Enhanced countdown function that uses reliable timing
  const countdownSoundRef = useRef(null);

  // Initialize countdown audio
  useEffect(() => {
    countdownSoundRef.current = new Audio("/Countdown.mp3");
    countdownSoundRef.current.preload = "auto";
  }, []);

  // Updated countdown function
  const beginCountdown = (value, value2, check, startingin) => {
    setCounDownCheck(check);

    // Clear existing interval
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    setCountdown(value2 === "Next Round Starts in" ? 4 : value);
    setCountdownText(value2);
    setCashoutOtherCheck(false);
    setGameState("countdown");
    setCrashed(false);

    // Store the new interval in the ref
    intervalRef.current = setInterval(() => {
      setCountdown((prev) => {
        // Play countdown sound for 3, 2, 1
        if (
          value2 === "Next Round Starts in" &&
          prev == 4 &&
          audioAllowed &&
          !document.hidden &&
          countdownSoundRef.current
        ) {
          countdownSoundRef.current.currentTime = 0;
          countdownSoundRef.current.play().catch((e) => {
            console.warn("Countdown sound play failed:", e);
          });
        }

        if (prev <= 1) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };
  const handleBetNow = async () => {
    setLoading(true);
    localStorage.setItem("AutoCashOut", autoCashout);

    if (!betAmount || parseFloat(betAmount) <= 0) return;
    try {
      let apiData = await apiCallPlaceBet(
        currentIndex > 0 ? currentIndex - 1 : currentIndex
      );

      const checkUserAllowance = await checkAllowance(
        smartAccount,
        CRASH_GAME_CONTRACT
      );

      if (betAmount > checkUserAllowance) {
        const {
          userPermissions: permissions,
          userSessionKey: sessionKey,
          isMobile: isMobile,
        } = await grantPermissions();
        const placebet = await PlaceBeteHook(
          apiData.data.data,
          betAmount,
          currentIndex,
          true,
          smartAccount,
          meClient,
          permissions,
          sessionKey
        );
        if (placebet) {
          fetchEthBalanceAfter1(
            currentIndex > 0 ? currentIndex - 1 : currentIndex
          );

          setBetPlaced(true);
          setLoading(false);
        }
      } else {
        const {
          userPermissions: permissions,
          userSessionKey: sessionKey,
          isMobile: isMobile,
        } = await grantPermissions();
        const placebet = await PlaceBeteHook(
          apiData.data.data,
          betAmount,
          currentIndex,
          false,
          smartAccount,
          meClient,
          permissions,
          sessionKey
        );
        if (placebet) {
          fetchEthBalanceAfter1(
            currentIndex > 0 ? currentIndex - 1 : currentIndex
          );

          setBetPlaced(true);
          setLoading(false);
        }
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };
  useEffect(() => {
    const storedTheme = localStorage.getItem("theme") || "dark";
    setTheme(storedTheme);
    document.documentElement.setAttribute("data-theme", storedTheme);
  }, []);

  const handleBetNext = () => {
    if (!autoBetAmount || parseFloat(autoBetAmount) <= 0) return;
    setAutoBetNext(true);
  };

  const handleCashout = () => {
    if (betPlaced && !crashed) {
      const win = parseFloat((parseFloat(betAmount) * multiplier).toFixed(2));
      setWinAmount(win);
      // setShowWinModal(true);
    }

    setShowCashout(false);
    setBetPlaced(false);
  };
  const [show, setShow] = useState(false);

  const [show1, setShow1] = useState(false);

  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);

  const [showbet3, setShowbet3] = useState(false);

  const handleClosebet3 = () => {
    setShowbet3(false);
    if (!crashed) {
      setCashoutOtherCheck(true);
      fetchEthBalanceAfter(currentIndex + 1);
    } else {
      setBetPlaced(false);
      fetchEthBalanceAfter(currentIndex);
    }
  };
  const handleShowbet3 = () => setShowbet3(true);
  const fetchEthBalance = async () => {
    try {
      const balance = await BalanceHook(smartAccount);
      setUserBalance(balance);
    } catch (error) {
      console.error("Error fetching ETH balance:", error);
    }
  };

  const fetchEthBalance3 = async (starttime, induxx, crashText) => {
    setGameSypherText(crashText);
    setIndexForCrsh(induxx);
    setGametartTimeContract(starttime);
    let index = induxx;
    try {
      let currentDate = new Date();
      currentDate = currentDate?.getTime() / 1000;
      setGameStartTime(starttime);
      let startin = starttime - currentDate;
      startin = parseInt(startin);

      beginCountdown(20, "Next Round Starts in", true, startin);
    } catch (error) {
      console.error("Error fetching ETH balance:", error);
    }
  };

  const apiCall = async () => {
    try {
      let url = `https://prod-api.luckify.bet/transactions/cashout`;
      const response = await axios.post(
        url,

        {
          walletAddress: smartAccount,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the Authorization header
            "Content-Type": "application/json", // Optional, depending on the API requirements
          },
        }
      );
      return response;
    } catch (err) {
      setcashoutBool(false);
      throw err;
    }
  };
  const apiCallPlaceBet = async (value) => {
    try {
      let url = `https://prod-api.luckify.bet/transactions/reveal`;
      const response = await axios.post(
        url,

        {
          round: value,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the Authorization header
            "Content-Type": "application/json", // Optional, depending on the API requirements
          },
        }
      );
      return response;
    } catch (err) {
      throw err;
    }
  };

  const apiCallafter1sec = async (value1, value2) => {
    // console.log(value1, value2, "value1, value2");

    let time = value1 ? value1 : gametartTimeContract;
    let text = value2 ? value2 : gameSypherText;

    try {
      let url = `https://prod-api.luckify.bet/transactions/isCrashed`;
      const response = await axios.post(
        url,

        { ciphertext: text, startTime: time },
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the Authorization header
            "Content-Type": "application/json", // Optional, depending on the API requirements
          },
        }
      );

      return response.data.data.isCrashed;
    } catch (err) {
      console.log(err, "err");

      throw err;
    }
  };

  const calshOutHandler = async () => {
    setcashoutBool(true);
    setLoading(true);
    const { userPermissions: permissions, userSessionKey: sessionKey } =
      await grantPermissions();
    try {
      let data = await apiCall();
      let date = data.data.data.time;
      let startTime = gameStartTime;
      let time = date - startTime;

      const placebet = await CashoutHook(
        data.data.data,
        smartAccount,
        currentIndex,
        meClient,
        publicClient,
        permissions,
        sessionKey
      );
      if (placebet) {
        let data = placebet?.logs;

        const interfaceCrashEvent = new ethers.Interface(CrashGameABI);
        let dataaaa = interfaceCrashEvent?.decodeEventLog(
          "CrashBetResolved",
          data[data?.length - 3].data
        );
        let amount = dataaaa[2];
        amount = web3?.utils?.fromWei(String(amount), "mwei");
        setWinprice(amount);
        setWinstatus(dataaaa[1]);
        let amount1 = pendingBetAmount ? pendingBetAmount : betAmount;
        let result = parseFloat(amount) / parseFloat(amount1);
        setWinnxxx(result);
        handleCashout();
        handleShowbet3();
        setBetPlaced(true);
        setLoading(false);
      }
    } catch (err) {
      setcashoutBool(false);
      console.log(err);
      setLoading(false);
    }
  };

  const fetchEthBalanceAfter = async (index) => {
    try {
      setCurrentIndex(index);
      let placeBet = await GamePendingHook(smartAccount, index);
      let placebetAmout = web3?.utils?.fromWei(
        String(placeBet?.amount),
        "mwei"
      );

      setPendingBetAmount(placebetAmout);
      setPendingBetStatus(placeBet.resolved);
    } catch (error) {
      console.error("Error fetching ETH balance:", error);
    }
  };

  const fetchEthBalanceAfter1 = async (index) => {
    try {
      setCurrentIndex(index);
      let placeBet = await GamePendingHook(smartAccount, index);
      let placebetAmout = web3.utils.fromWei(String(placeBet.amount), "mwei");

      setPendingBetAmount(placebetAmout);
      setPendingBetStatus(placeBet.resolved);
    } catch (error) {
      console.error("Error fetching ETH balance:", error);
    }
  };

  const fetchPlayerHistory = async () => {
    const query = `
      query CrashBetResolved {
        crashBetResolveds(where: { player: "${smartAccount}" }) {
        index
          won
          transactionHash
          amount
          timepassed
          player
          payout
          id
          blockTimestamp
          blockNumber
        }
      }
    `;

    try {
      const data = await callCrashGameGraphQLQuery(query);

      const allBets = data?.crashBetResolveds || [];

      // ✅ Sort by blockTimestamp descending to get the latest on top
      const sortedHistory = allBets.sort(
        (a, b) => Number(b.blockTimestamp) - Number(a.blockTimestamp)
      );

      setPlayerHistory(sortedHistory);
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch bet history:", error);
      setLoading(false);
    }
  };
  const fetchPlayerBetHistory = async () => {
    const placedBetsQuery = `
    query CrashBetPlaced {
    
      crashBetPlaceds(where: { player: "${smartAccount}" }) {
        index
        amount
        blockTimestamp
        transactionHash
         blockNumber
    blockTimestamp
      }
    }
  `;

    try {
      const data = await callCrashGameGraphQLQuery(placedBetsQuery);
      const allBets = data?.crashBetPlaceds || [];

      // ✅ Sort by blockTimestamp descending to get the latest on top
      const sortedHistory = allBets.sort(
        (a, b) => Number(b.blockTimestamp) - Number(a.blockTimestamp)
      );
      setPlayerBetHistory(sortedHistory);
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch bet history:", error);
      setLoading(false);
    }
  };
  const fetchGraphChartsData = async () => {
    const query = `
    query PreviousRounds {
      previousRounds(first: 10000, orderBy: blockNumber, orderDirection: desc) {
        transactionHash
        indexId
        rng
      }
    }
  `;

    try {
      const data = await callCrashGameGraphQLQuery(query);

      const recentGames = data?.previousRounds || [];
      setRecentGamesData(recentGames);
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch graph chart data:", error);
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!playerHistory.length || !playerBetHHistory.length) return;

    const resolvedIndexSet = new Set(playerHistory.map((bet) => bet.index));
    const merged = [];

    playerBetHHistory.forEach((placedBet) => {
      if (resolvedIndexSet.has(placedBet.index)) {
        const winBet = playerHistory.find(
          (resolved) => resolved.index === placedBet.index
        );

        if (winBet) {
          merged.push({
            ...winBet,
            type: "win",
          });
        }
      } else {
        merged.push({
          ...placedBet,
          type: "loss",
        });
      }
    });

    setMergedBetHistory(merged);
  }, [playerHistory, playerBetHHistory]);

  useEffect(() => {
    if (gameState == "waiting") {
      if (smartAccount) {
        // fetchEthBalanceEth();
        fetchEthBalance();
        fetchEthBalance2();

        fetchPlayerHistory();
        fetchPlayerBetHistory();
        fetchData();
        fetchGraphChartsData();
      } else {
        fetchData();
        fetchEthBalance2();
        fetchGraphChartsData();
      }
    }
  }, [smartAccount, gameState]);

  useEffect(() => {
    if (gameState == "waiting") {
      if (smartAccount) {
        setTimeout(() => {
          fetchEthBalance();
        }, 7000);
      }
    }
  }, [smartAccount, gameState]);

  function shortenAddress(address, chars = 4) {
    if (!address) return "";
    return `${address.slice(0, 2 + chars)}...${address.slice(-chars)}`;
  }
  useEffect(() => {
    if (cashoutSaved) {
      setAutoCashOut(cashoutSaved);
    }
  }, [cashoutSaved]);
  useEffect(() => {
    if (!cashoutBool && parseFloat(multiplier) === parseFloat(autoCashout)) {
      calshOutHandler();
    }
  }, [multiplier]);

  const fetchData = async () => {
    try {
      const liquidity = await TotalLiquidityHook(
        CrashGameContract,
        CRASH_GAME_CONTRACT
      );
      const winnings = await TotalWinningHook(
        CrashGameContract,
        CRASH_GAME_CONTRACT
      );
      const volume = await TotalVolumeHook(
        CrashGameContract,
        CRASH_GAME_CONTRACT
      );
      setCurrentLiquidity(liquidity);
      setTotalWinnings(winnings);
      setTotalVolume(volume);
      // setJackPot(jackPot);
      setbaughtBack(baughtBack);
      const calculateMaxBet = liquidity / 95 / 5;
      setMaxBet(calculateMaxBet);
    } catch (error) {
      console.error("Error fetching ETH balance:", error);
    }
  };

  const fetchEthBalance2 = async () => {
    setLoading(true);
    try {
      let index = await GameCurrentIndexHood();
      let checkindex = index;
      index = index > 0 ? index - 1 : index;
      let currentRount = await GameRoundHook(index);
      if (checkindex > 0) {
        let currentDate = new Date();
        currentDate = currentDate?.getTime() / 1000;
        let startin = currentDate - currentRount.startTime;
        setGameSypherText(currentRount.crashDelay);
        setGametartTimeContract(currentRount.startTime);
        setGameStartTime(currentRount.startTime);
        let value = 100;
        value = value - 10;
        value = value / 5;
        value = value + 1;
        let aaa = await apiCallafter1sec(
          currentRount.startTime,
          currentRount.crashDelay
        );

        if (aaa) {
          fetchEthBalanceAfter(checkindex == 0 ? 0 : index + 1);
        } else {
          startRound(200, startin <= 0 ? 0 : startin);
          setShouldRun(true);
          fetchEthBalanceAfter(checkindex == 0 ? 0 : index);
        }
      } else {
        fetchEthBalanceAfter(checkindex == 0 ? 0 : index);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching ETH balance:", error);
    }
  };
  useEffect(() => {
    if (indexForCRASH >= 0) {
      fetchEthBalanceAfter(indexForCRASH);
    }
  }, [indexForCRASH]);
  const getColorClass = (ethValue) => {
    if (ethValue > 2 && ethValue < 10) return "green";
    if (ethValue <= 2) return "yellow";
    return "purple";
  };
  const handleChange = (e) => {
    const input = e.target.value;

    if (input === "") {
      setAutoCashOut("");
      return;
    }
    if (input < 1) {
      setAutoCashOut("");
      return;
    }

    if (!/^\d*\.?\d*$/.test(input)) return;

    if (input.includes(".")) {
      const [intPart, decimalPart] = input.split(".");
      if (decimalPart.length > 2) return;
    }

    setAutoCashOut(input);
  };

  useEffect(() => {
    if (!showbet3) return;

    const audio = new Audio("/assets/win.mp3");
    audio.play().catch((e) => {
      console.error("Audio play failed:", e);
    });

    return () => {
      audio.pause();
      audio.currentTime = 0;
    };
  }, [showbet3]);

  return (
    <>
      <WalletConnectModel
        theme={theme}
        show={show11}
        handleClose={handleClose11}
      />
      {loading && <Loader text={loaderText} />}
      <section className="moonmain">
        <div className="custom-container">
          <h6 className="moonhead">Crash</h6>

          <div className="moonupper">
            <div className="upperleft">
              <div className="leftupper">
                <div className="upperinnerleft">
                  {recentGamesData.slice(0, 4).map((item, index) => {
                    const rawValue = parseFloat(10000 / item.rng);
                    const randomEth = rawValue;

                    let circleClass = "greencircle";
                    let textClass = "greentext";

                    if (randomEth > 2 && randomEth <= 10) {
                      circleClass = "yellowcircle";
                      textClass = "yellowtext";
                    } else if (randomEth > 10) {
                      circleClass = "purplecircle";
                      textClass = "purpletext";
                    }
                    return (
                      <div className="upperinner" key={index}>
                        <span className={`circle ${circleClass}`}></span>
                        <div className="innertexts">
                          <p className="innerpara">{item.indexId}</p>
                          <h6 className={`innerhead ${textClass}`}>
                            {isFinite(randomEth)
                              ? `${randomEth.toFixed(2)}x`
                              : "0x"}
                          </h6>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <Dropdown
                  className="upperdropdown"
                  align="end"
                  show={show}
                  onToggle={() => setShow((prev) => !prev)}
                >
                  <Dropdown.Toggle
                    id="dropdown-basic"
                    onClick={() => setShow(!show)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M2.5 10C2.5 11.4834 2.93987 12.9334 3.76398 14.1668C4.58809 15.4001 5.75943 16.3614 7.12987 16.9291C8.50032 17.4968 10.0083 17.6453 11.4632 17.3559C12.918 17.0665 14.2544 16.3522 15.3033 15.3033C16.3522 14.2544 17.0665 12.918 17.3559 11.4632C17.6453 10.0083 17.4968 8.50032 16.9291 7.12987C16.3614 5.75943 15.4001 4.58809 14.1668 3.76398C12.9334 2.93987 11.4834 2.5 10 2.5C7.90329 2.50789 5.89081 3.32602 4.38333 4.78333L2.5 6.66667"
                        stroke="#F24CA2"
                        stroke-width="1.25"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M2.5 2.5V6.66667H6.66667"
                        stroke="#F24CA2"
                        stroke-width="1.25"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M10 5.8335V10.0002L13.3333 11.6668"
                        stroke="#F24CA2"
                        stroke-width="1.25"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <div className="dropmain">
                      <div className="drophead">
                        <h6 className="dropheading">History</h6>
                        <button
                          className="closebtn"
                          onClick={() => setShow(false)}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            className="lightsvg"
                          >
                            <path
                              d="M18 6L6 18"
                              stroke="#13151A"
                              stroke-width="1.25"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M6 6L18 18"
                              stroke="#13151A"
                              stroke-width="1.25"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            className="darksvg"
                          >
                            <path
                              d="M18 6L6 18"
                              stroke="white"
                              stroke-width="1.25"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M6 6L18 18"
                              stroke="white"
                              stroke-width="1.25"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </button>
                      </div>
                      <div className="dropbody">
                        <div className="maintable">
                          <table>
                            <thead>
                              <th>Round</th>
                              <th>Result</th>
                              {/* <th>Hash</th> */}
                            </thead>
                            <tbody>
                              {recentGamesData?.slice(4).map((item, index) => {
                                const rng = parseFloat(10000 / item.rng); // <- direct use of rng
                                let color = "green";

                                if (rng > 2 && rng <= 10) {
                                  color = "yellow";
                                } else if (rng > 10) {
                                  color = "purple";
                                }
                                const txHash = item.transactionHash;
                                const shortTx = `${txHash.slice(
                                  0,
                                  6
                                )}...${txHash.slice(-4)}`;

                                return (
                                  <tr key={index}>
                                    <td>
                                      <div className="mainnumber">
                                        <span
                                          className={`circle ${color}`}
                                        ></span>
                                        <p
                                          className={`numberpara ${color}text`}
                                        >
                                          {item.indexId}
                                        </p>
                                      </div>
                                    </td>
                                    <td>
                                      {isFinite(rng)
                                        ? `${rng.toFixed(2)}X`
                                        : "0X"}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
                <button className="mobilesidebtn d-none" onClick={handleShow1}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M2.5 10C2.5 11.4834 2.93987 12.9334 3.76398 14.1668C4.58809 15.4001 5.75943 16.3614 7.12987 16.9291C8.50032 17.4968 10.0083 17.6453 11.4632 17.3559C12.918 17.0665 14.2544 16.3522 15.3033 15.3033C16.3522 14.2544 17.0665 12.918 17.3559 11.4632C17.6453 10.0083 17.4968 8.50032 16.9291 7.12987C16.3614 5.75943 15.4001 4.58809 14.1668 3.76398C12.9334 2.93987 11.4834 2.5 10 2.5C7.90329 2.50789 5.89081 3.32602 4.38333 4.78333L2.5 6.66667"
                      stroke="#F24CA2"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M2.5 2.5V6.66667H6.66667"
                      stroke="#F24CA2"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10 5.8335V10.0002L13.3333 11.6668"
                      stroke="#F24CA2"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </div>
              <div className="crashgame">
                <h1
                  className="multiplier"
                  style={{
                    visibility:
                      gameState === "countdown" ? "hidden" : "visible",
                  }}
                >
                  {multiplier ? multiplier.toFixed(2) : "0.00"}
                  x <br />
                  {crashed && <span className="crashspan">Crashed</span>}
                </h1>
                {gameState === "countdown" && (
                  <div className="progressbarr">
                    <div
                      className="innerprogress"
                      style={{
                        width: `${progressPercent}%`,
                        transition: "width 1s linear",
                      }}
                    ></div>
                    <p className="progresspara">
                      {countdownText} {`(${countdown}s)`}
                    </p>
                  </div>
                )}
                <div className="innercrashgame">
                  <img
                    src="/assets/stars.svg"
                    alt="stars"
                    className="starsmainimg"
                    style={{
                      visibility:
                        gameState === "countdown" ? "hidden" : "visible",
                    }}
                  />
                  <div
                    ref={container2}
                    className="moonmainimg"
                    style={{
                      visibility:
                        gameState === "countdown" ? "hidden" : "visible",
                    }}
                  ></div>
                  <div className="x-axis">
                    {xLabels.map((val, idx) => (
                      <span className="xnumber" key={idx}>
                        {val}
                      </span>
                    ))}
                  </div>
                  <div className="rightgraph">
                    <div className="linemain">
                      <div
                        className="maininnerline"
                        style={{
                          visibility:
                            gameState === "countdown" ? "hidden" : "visible",
                        }}
                      >
                        {window.innerWidth < 600 ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="421"
                            height="446"
                            viewBox="0 0 421 446"
                            fill="none"
                            className="lineinner"
                          >
                            <g filter="url(#filter0_d_912_587)">
                              <path
                                id="crashPath"
                                ref={pathRef}
                                d="M4 423C4 423 65.8308 401.491 133.192 335.5C200.553 269.508 292.11 184.309 339 140"
                                stroke={crashed ? "#FF3434" : "#F24CA2"}
                                stroke-width="4"
                                stroke-linecap="round"
                              />
                            </g>
                            <defs>
                              <filter
                                id="filter0_d_912_587"
                                x="-0.000488281"
                                y="-0.000488281"
                                width="421.001"
                                height="446.001"
                                filterUnits="userSpaceOnUse"
                                color-interpolation-filters="sRGB"
                              >
                                <feFlood
                                  flood-opacity="0"
                                  result="BackgroundImageFix"
                                />
                                <feColorMatrix
                                  in="SourceAlpha"
                                  type="matrix"
                                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                  result="hardAlpha"
                                />
                                <feOffset dx="19" />
                                <feGaussianBlur stdDeviation="10.5" />
                                <feComposite in2="hardAlpha" operator="out" />
                                <feColorMatrix
                                  type="matrix"
                                  values={
                                    crashed
                                      ? "0 0 0 0 1 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 1 0"
                                      : "0 0 0 0 0.690 0 0 0 0 0.471 0 0 0 0 1 0 0 0 1 0"
                                  }
                                />
                                <feBlend
                                  mode="normal"
                                  in2="BackgroundImageFix"
                                  result="effect1_dropShadow_912_587"
                                />
                                <feBlend
                                  mode="normal"
                                  in="SourceGraphic"
                                  in2="effect1_dropShadow_912_587"
                                  result="shape"
                                />
                              </filter>
                            </defs>
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="730"
                            height="309"
                            viewBox="0 0 730 309"
                            fill="none"
                            className="lineinner"
                          >
                            <g filter="url(#filter0_d)">
                              <path
                                id="crashPath"
                                ref={pathRef}
                                d="M0.000244141 304C0.000244141 304 135.204 285.933 282.5 230.5C429.796 175.067 530 103.5 580 90"
                                stroke={crashed ? "#FF3434" : "#F24CA2"}
                                strokeWidth="4"
                                strokeLinecap="round"
                              />
                            </g>
                            <defs>
                              <filter
                                id="filter0_d"
                                x="-4"
                                y="-55"
                                width="730"
                                height="382"
                                filterUnits="userSpaceOnUse"
                              >
                                <feFlood floodOpacity="0" />
                                <feColorMatrix
                                  in="SourceAlpha"
                                  type="matrix"
                                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                />
                                <feOffset dx="19" />
                                <feGaussianBlur stdDeviation="10.5" />
                                <feComposite in2="hardAlpha" operator="out" />
                                <feColorMatrix
                                  type="matrix"
                                  values={
                                    crashed
                                      ? "0 0 0 0 1 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 1 0"
                                      : "0 0 0 0 0.690 0 0 0 0 0.471 0 0 0 0 1 0 0 0 1 0"
                                  }
                                />
                                <feBlend
                                  mode="normal"
                                  in2="BackgroundImageFix"
                                  result="effect1_dropShadow"
                                />
                                <feBlend
                                  mode="normal"
                                  in="SourceGraphic"
                                  in2="effect1_dropShadow"
                                  result="shape"
                                />
                              </filter>
                            </defs>
                          </svg>
                        )}

                        <div ref={rocketRef} className="rocket" id="rocket" />
                      </div>
                      <div className="innerlines">
                        {[...Array(5)].map((_, i) => (
                          <div className="innerborder" key={i}></div>
                        ))}
                      </div>
                    </div>
                    <div className="y-axis">
                      {yLabels.map((val, idx) => (
                        <span className="xnumber" key={idx}>
                          {val}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              {account ? (
                <>
                  {!countDownCheck ? (
                    <>
                      {(gameState === "waiting" &&
                        !betPlaced &&
                        pendingBetAmount == 0) ||
                      (!betPlaced &&
                        pendingBetAmount == 0 &&
                        gameState === "countdown") ? (
                        <button
                          onClick={handleBetNow}
                          disabled={
                            !betAmount ||
                            parseFloat(betAmount) < 1 ||
                            parseFloat(betAmount) > parseFloat(userBalance) ||
                            parseFloat(betAmount) > parseFloat(maxBet)
                              ? true
                              : false
                          }
                          className="betbtn"
                        >
                          Place Bet
                        </button>
                      ) : (
                        <>
                          {gameState === "running" && pendingBetAmount > 0 ? (
                            <button
                              onClick={() => {
                                calshOutHandler();
                              }}
                              className="cashoutbtn"
                            >
                              <span className="dollars"></span>
                              Cash Out
                            </button>
                          ) : (
                            <>
                              <button
                                disabled={true}
                                onClick={handleBetNext}
                                className="betbtn"
                              >
                                YOUR BET IS PLACED
                              </button>
                            </>
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {pendingBetAmount > 0 ? (
                        <button
                          disabled={true}
                          onClick={handleBetNext}
                          className="betbtn"
                        >
                          YOUR BET IS PLACED
                        </button>
                      ) : (
                        <button
                          disabled={true}
                          onClick={handleBetNext}
                          className="betbtn"
                        >
                          Bet
                          <span className="bigtext">(Next Round)</span>
                        </button>
                      )}
                    </>
                  )}
                </>
              ) : (
                <>
                  <button className="betbtn" onClick={handleShow11}>
                    Connect Wallet
                  </button>
                </>
              )}
              <h6 className="midhead">Play the Game</h6>
              <div className="midparas">
                <p className="innerpara">
                  <span className="dullpara">Min Bet</span> $1
                </p>
                <p className="innerpara">
                  <span className="dullpara">Max Bet</span> $
                  {+maxBet?.toFixed(2)}
                </p>
              </div>
              <div className="leftlow">
                <div className="lowinner">
                  <div className="amountupper">
                    <p className="amountpara">Amount</p>
                    <p className="amountpara">
                      Balance:{" "}
                      <span className="mainamount">
                        {" "}
                        {(+userBalance)?.toFixed(4)} USDC
                      </span>
                    </p>
                  </div>
                  <div className="maininput">
                    <input
                      placeholder="0"
                      onWheel={(e) => e.target.blur()}
                      value={betAmount}
                      onChange={(e) => setBetAmount(e.target.value)}
                      type="number"
                      className={
                        (parseFloat(betAmount) && parseFloat(betAmount) < 1) ||
                        parseFloat(betAmount) > parseFloat(userBalance) ||
                        parseFloat(betAmount) > parseFloat(maxBet)
                          ? "inputinner redborder"
                          : "inputinner"
                      }
                    />
                    <div className="maintokenimg">
                      <img
                        src="\assets\playassets\usdc.svg"
                        alt="tokenimg"
                        className="tokenimg"
                      />
                      <img
                        src="\assets\playassets\base.svg"
                        alt="baseimg"
                        className="baseimg"
                      />
                    </div>
                  </div>
                  <div className="buttonsmain">
                    <button
                      className="innerbtn"
                      onClick={() => {
                        setBetAmount(10);
                      }}
                    >
                      10
                    </button>
                    <button
                      className="innerbtn"
                      onClick={() => {
                        setBetAmount(100);
                      }}
                    >
                      100
                    </button>
                    <button
                      className="innerbtn"
                      onClick={() => {
                        setBetAmount(1000);
                      }}
                    >
                      1.0k
                    </button>
                    <button
                      className="innerbtn"
                      onClick={() => {
                        if (maxBet > userBalance) {
                          setBetAmount(userBalance - 0.000000001);
                        } else {
                          setBetAmount(maxBet - 0.000000001);
                        }
                      }}
                    >
                      MAX
                    </button>
                  </div>
                </div>
                <div className="lowinner">
                  <div className="amountupper">
                    <p className="amountpara">Auto Cash out</p>
                    <p className="amountpara">Chance 0.99%</p>
                  </div>
                  <div className="maininput">
                    <input
                      value={autoCashout}
                      onWheel={(e) => e.target.blur()}
                      placeholder="0"
                      type="number"
                      className="inputinner"
                      onChange={handleChange}
                    />
                  </div>
                  <div className="buttonsmain">
                    <button
                      className="innerbtn"
                      onClick={() => {
                        setAutoCashOut(1);
                      }}
                    >
                      1
                    </button>
                    <button
                      className="innerbtn"
                      onClick={() => {
                        setAutoCashOut(2);
                      }}
                    >
                      2
                    </button>
                    <button
                      className="innerbtn"
                      onClick={() => {
                        setAutoCashOut(10);
                      }}
                    >
                      10
                    </button>
                    <button
                      className="innerbtn"
                      onClick={() => {
                        setAutoCashOut(100);
                      }}
                    >
                      100
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="rightbottom">
              <RoundData
                currentIndex={currentIndex}
                shouldRun={shouldRun}
                shouldCrashNow={shouldCrashNow}
              />
            </div>
          </div>
          <section className="maininnerlower">
            <div className="playtable">
              <h6 class="playhead">My Bet History</h6>
              <div className="maintable">
                <div className="innertable">
                  <table>
                    <thead>
                      <tr>
                        <th>TransactionHash</th>
                        <th>Bet Amount</th>
                        <th> BlockNumber</th>
                        <th>Bet Place Time</th>
                        <th>Status</th>
                        <th>CashOut</th>
                      </tr>
                    </thead>
                    <tbody>
                      {account ? (
                        mergedBetHistory && mergedBetHistory.length > 0 ? (
                          mergedBetHistory.map((bet, i) => (
                            <tr key={i}>
                              <td>
                                <div className="mainlink">
                                  <p className="innerlink">
                                    {shortenAddress(bet.transactionHash)}
                                  </p>
                                  <a
                                    href={`https://basescan.org/tx/${bet.transactionHash}`}
                                    className="innerlink"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="13"
                                      height="12"
                                      viewBox="0 0 13 12"
                                      fill="none"
                                    >
                                      <path
                                        d="M11.1667 6.5V9.5C11.1667 9.76522 11.0614 10.0196 10.8739 10.2071C10.6863 10.3946 10.432 10.5 10.1667 10.5H3.16675C2.90153 10.5 2.64718 10.3946 2.45964 10.2071C2.2721 10.0196 2.16675 9.76522 2.16675 9.5V2.5C2.16675 2.23478 2.2721 1.98043 2.45964 1.79289C2.64718 1.60536 2.90153 1.5 3.16675 1.5H6.16675"
                                        stroke="#3E3F43"
                                        stroke-width="1.04"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M11.1667 1.5L6.66675 6"
                                        stroke="#3E3F43"
                                        stroke-width="1.04"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M8.16675 1.5H11.1667V4.5"
                                        stroke="#3E3F43"
                                        stroke-width="1.04"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>
                                  </a>
                                </div>
                              </td>

                              {/* Bet Amount */}
                              <td>
                                $
                                {(() => {
                                  const amountInEther = parseFloat(
                                    Web3?.utils?.fromWei(
                                      String(bet?.amount),
                                      "mwei"
                                    )
                                  );

                                  const finalAmount =
                                    bet.type === "win"
                                      ? amountInEther
                                      : amountInEther * 0.95; // Deduct 5%

                                  return finalAmount.toFixed(2);
                                })()}
                              </td>

                              {/* Block Number */}
                              <td>{bet?.blockNumber}</td>

                              {/* Timestamp */}
                              <td>
                                <p>
                                  {new Date(
                                    bet.blockTimestamp * 1000
                                  ).toLocaleString("en-US", {
                                    day: "2-digit",
                                    month: "short",
                                    year: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: true,
                                  })}
                                </p>
                              </td>

                              {/* Optional: Show win/loss */}
                              <td>
                                {bet.type === "win" ? (
                                  <span style={{ color: "green" }}>Win</span>
                                ) : (
                                  <span style={{ color: "red" }}>Loss</span>
                                )}
                              </td>

                              {/* Optional: Payout */}
                              <td>
                                {bet.type === "win" ? (
                                  <span style={{ color: "green" }}>
                                    $
                                    {parseFloat(
                                      Web3?.utils?.fromWei(
                                        String(bet.payout),
                                        "mwei"
                                      )
                                    ).toFixed(2)}
                                  </span>
                                ) : (
                                  <span style={{ color: "red" }}>$0</span>
                                )}
                              </td>
                            </tr>
                          ))
                        ) : (
                          // No bets yet
                          <tr>
                            <td colSpan={6}>
                              <div className="connectwalletmain w-100">
                                {/* Your "No Bets" UI */}
                                <h6 className="connecthead">
                                  You Haven't Placed Any Bets Yet
                                </h6>
                                <p className="connectpara">
                                  Your bets will show up here after you place
                                  one.
                                </p>
                              </div>
                            </td>
                          </tr>
                        )
                      ) : (
                        // Wallet not connected
                        <tr>
                          <td colSpan={6}>
                            <div className="connectwalletmain w-100">
                              {/* Your "Connect Wallet" UI */}
                              <h6 className="connecthead">
                                You Haven't Connected Your Wallet Yet
                              </h6>
                              <p className="connectpara">
                                Click here to connect your wallet.
                              </p>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="mainboxes d-block d-md-none">
                {account ? (
                  mergedBetHistory && mergedBetHistory.length > 0 ? (
                    mergedBetHistory.map((bet, index) => (
                      <div className="mainbox" key={index}>
                        <div className="innerbox">
                          <p className="boxpara">Bet ID</p>
                          <h6 className="boxhead">
                            <a
                              href={`https://basescan.org/tx/${bet.transactionHash}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="innerlink"
                            >
                              {bet.transactionHash.slice(0, 12)}...
                            </a>
                          </h6>
                        </div>
                        <div className="innerbox">
                          <p className="boxpara">Bet Amount</p>
                          <h6 className="boxhead">
                            $
                            {(() => {
                              const amountInEther = parseFloat(
                                Web3?.utils?.fromWei(
                                  String(bet?.amount),
                                  "mwei"
                                )
                              );

                              const finalAmount =
                                bet.type === "win"
                                  ? amountInEther
                                  : amountInEther * 0.95; // Deduct 5%

                              return finalAmount.toFixed(2);
                            })()}
                            {/* ${parseFloat(Web3.utils.fromWei(String(bet.amount), "ether")).toFixed(2)} */}
                          </h6>
                        </div>
                        <div className="innerbox">
                          <p className="boxpara">BlockNumber</p>
                          <h6 className="boxhead">{bet?.blockNumber}</h6>
                        </div>
                        <div className="innerbox">
                          <p className="boxpara"> Bet Place Time</p>
                          <p style={{ fontSize: "12px" }}>
                            {new Date(bet.blockTimestamp * 1000).toLocaleString(
                              "en-US",
                              {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true, // optional: for AM/PM format
                              }
                            )}
                          </p>
                        </div>
                        <div className="innerbox">
                          <p className="boxpara"> Status</p>
                          {bet.type === "win" ? (
                            <span style={{ color: "green" }}>Win</span>
                          ) : (
                            <span style={{ color: "red" }}>Loss</span>
                          )}
                        </div>
                        <div className="innerbox">
                          <p className="boxpara"> CashOut</p>
                          {bet.type === "win" ? (
                            <span style={{ color: "green" }}>
                              $
                              {parseFloat(
                                Web3?.utils?.fromWei(String(bet.payout), "mwei")
                              ).toFixed(2)}
                            </span>
                          ) : (
                            <span style={{ color: "red" }}>$0</span>
                          )}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="connectwalletmain w-100">
                      <span className="mainimg">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="38"
                          height="38"
                          viewBox="0 0 38 38"
                          fill="none"
                        >
                          <path
                            d="M30.0833 11.0833V6.33333C30.0833 5.91341 29.9165 5.51068 29.6196 5.21375C29.3227 4.91681 28.9199 4.75 28.5 4.75H7.91667C7.07681 4.75 6.27136 5.08363 5.6775 5.6775C5.08363 6.27136 4.75 7.07681 4.75 7.91667C4.75 8.75652 5.08363 9.56197 5.6775 10.1558C6.27136 10.7497 7.07681 11.0833 7.91667 11.0833H31.6667C32.0866 11.0833 32.4893 11.2501 32.7863 11.5471C33.0832 11.844 33.25 12.2467 33.25 12.6667V19M33.25 19H28.5C27.6601 19 26.8547 19.3336 26.2608 19.9275C25.667 20.5214 25.3333 21.3268 25.3333 22.1667C25.3333 23.0065 25.667 23.812 26.2608 24.4058C26.8547 24.9997 27.6601 25.3333 28.5 25.3333H33.25C33.6699 25.3333 34.0727 25.1665 34.3696 24.8696C34.6665 24.5727 34.8333 24.1699 34.8333 23.75V20.5833C34.8333 20.1634 34.6665 19.7607 34.3696 19.4637C34.0727 19.1668 33.6699 19 33.25 19Z"
                            stroke="#F24CA2"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M4.75 7.9165V30.0832C4.75 30.923 5.08363 31.7285 5.6775 32.3223C6.27136 32.9162 7.07681 33.2498 7.91667 33.2498H31.6667C32.0866 33.2498 32.4893 33.083 32.7863 32.7861C33.0832 32.4892 33.25 32.0864 33.25 31.6665V25.3332"
                            stroke="#F24CA2"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <h6 className="connecthead">
                        You Haven't Placed Any Bets Yet
                      </h6>
                      <p className="connectpara">
                        Your bets will show up here after you place one.
                      </p>
                    </div>
                  )
                ) : (
                  <div className="connectwalletmain w-100">
                    <span className="mainimg">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="38"
                        height="38"
                        viewBox="0 0 38 38"
                        fill="none"
                      >
                        <path
                          d="M30.0833 11.0833V6.33333C30.0833 5.91341 29.9165 5.51068 29.6196 5.21375C29.3227 4.91681 28.9199 4.75 28.5 4.75H7.91667C7.07681 4.75 6.27136 5.08363 5.6775 5.6775C5.08363 6.27136 4.75 7.07681 4.75 7.91667C4.75 8.75652 5.08363 9.56197 5.6775 10.1558C6.27136 10.7497 7.07681 11.0833 7.91667 11.0833H31.6667C32.0866 11.0833 32.4893 11.2501 32.7863 11.5471C33.0832 11.844 33.25 12.2467 33.25 12.6667V19M33.25 19H28.5C27.6601 19 26.8547 19.3336 26.2608 19.9275C25.667 20.5214 25.3333 21.3268 25.3333 22.1667C25.3333 23.0065 25.667 23.812 26.2608 24.4058C26.8547 24.9997 27.6601 25.3333 28.5 25.3333H33.25C33.6699 25.3333 34.0727 25.1665 34.3696 24.8696C34.6665 24.5727 34.8333 24.1699 34.8333 23.75V20.5833C34.8333 20.1634 34.6665 19.7607 34.3696 19.4637C34.0727 19.1668 33.6699 19 33.25 19Z"
                          stroke="#F24CA2"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M4.75 7.9165V30.0832C4.75 30.923 5.08363 31.7285 5.6775 32.3223C6.27136 32.9162 7.07681 33.2498 7.91667 33.2498H31.6667C32.0866 33.2498 32.4893 33.083 32.7863 32.7861C33.0832 32.4892 33.25 32.0864 33.25 31.6665V25.3332"
                          stroke="#F24CA2"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                    <h6 className="connecthead">
                      You Haven't Connected Your Wallet Yet
                    </h6>
                    <p className="connectpara">
                      Click here to connect your wallet.
                    </p>
                    {/* <button className="connectbtn">Connect Wallet</button> */}
                  </div>
                )}
              </div>
            </div>
          </section>
        </div>
      </section>

      <Modal
        className="betmodal newwinmodal"
        show={showbet3}
        onHide={handleClosebet3}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Congrats!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img src="/assets/won.gif" alt="wongif" className="mainbetimage" />

          <div className="smallmainbox">
            <p className="bluepara">{winxxx?.toFixed(2)}x</p>
          </div>
          <div className="lowerbox">
            <p className="wonpara">You Won</p>
            <h6 className="texttt">${Number(winPrice).toFixed(4)}</h6>
          </div>
          <p className="bottompara">
            Your winnings have been transferred to your wallet.
          </p>
          <div className="twicebutton">
            <button onClick={handleClosebet3} className="close">
              Close
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Offcanvas
        show={show1}
        onHide={handleClose1}
        className="historysidebar"
        placement="bottom"
      >
        <Offcanvas.Header>
          <Offcanvas.Title>History</Offcanvas.Title>
          <button className="closebtn" onClick={() => setShow1(false)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              className="lightsvg"
            >
              <path
                d="M18 6L6 18"
                stroke="#13151A"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6 6L18 18"
                stroke="#13151A"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              className="darksvg"
            >
              <path
                d="M18 6L6 18"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6 6L18 18"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="dropmain">
            <div className="dropbody">
              <div className="maintable">
                <table>
                  <thead>
                    <th>Round</th>
                    <th>Result</th>
                  </thead>
                  <tbody>
                    {recentGamesData?.slice(4).map((item, index) => {
                      const rng = parseFloat(10000 / item.rng); // <-- use rng directly
                      const txHash = item.transactionHash;
                      const shortTx = `${txHash.slice(0, 6)}...${txHash.slice(
                        -4
                      )}`;

                      // Updated RNG-based style logic
                      let circleClass = "green";
                      let textClass = "greentext";

                      if (rng > 2 && rng <= 10) {
                        circleClass = "yellow";
                        textClass = "yellowtext";
                      } else if (rng > 10) {
                        circleClass = "purple";
                        textClass = "purpletext";
                      }

                      return (
                        <tr key={index}>
                          <td>
                            <div className="mainnumber">
                              <span className={`circle ${circleClass}`}></span>
                              <p className={`numberpara ${textClass}`}>
                                {item.indexId}
                              </p>
                            </div>
                          </td>
                          <td>{isFinite(rng) ? `${rng.toFixed(2)}X` : "0X"}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Themoon;
